// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://knsseskgwtfjpnihjlam.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtuc3Nlc2tnd3RmanBuaWhqbGFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2MTMyNTksImV4cCI6MjA1NjE4OTI1OX0.am8ZArTR_jlhnNJZXDxBrI3pFOq5ihuMR5RblpysVfU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);